// Module
var code = "<a data-bind=\"text: $parent.GetValue(Name)\" href=\"#\" data-type=\"text\"></a>";
// Exports
export default code;